const countDown = {
  beforeMount(el, binding) {
    el.__countdownHandler = () => {
      let countdown = binding.value;
      el.disabled = true;
      el.style.opacity = 0.6;
      el.style.cursor = `not-allowed`;
      el.textContent = `重新发送(${countdown}s)`;

      const timer = setInterval(() => {
        countdown--;
        if (countdown > 0) {
          el.textContent = `重新发送(${countdown}s)`;
        } else {
          el.textContent = "发送验证码";
          el.disabled = false;
          el.style.opacity = 1;
          el.style.cursor = `pointer`;
          clearInterval(timer);
        }
      }, 1000);
    };

    el.addEventListener("click", el.__countdownHandler);
  },
  unmounted(el) {
    el.removeEventListener("click", el.__countdownHandler);
  },
};

export default countDown;